import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router';
import { SlateContext, useSlate, useSlateKit } from '../hooks';
import { useQuery } from '../utils';
import { getSlateProps } from '../utils/slate-props.utils';
import { BlockContainer } from './BlockContainer.component';
export const SlateRenderer = ({ slate, path: customPath, additionalContext = {}, }) => {
    const urlParams = useParams();
    const queryParams = useQuery();
    const slateKitProps = useSlateKit();
    const { kit } = slateKitProps;
    const { context: slateContext = {} } = useSlate();
    if (!slate)
        return null;
    const { path: initialPath } = slateContext;
    const SlateWrapper = kit.loadSlateWrapper();
    const content = _jsx(BlockContainer, { childId: "all" }, void 0);
    return (_jsx(SlateContext.Provider, Object.assign({ value: getSlateProps(slateKitProps, {
            rawSlate: slate,
            context: Object.assign({ path: customPath || initialPath, urlParams,
                queryParams }, additionalContext),
        }) }, { children: SlateWrapper ? _jsx(SlateWrapper, { children: content }, void 0) : content }), void 0));
};
//# sourceMappingURL=SlateRenderer.component.js.map